import { render, staticRenderFns } from "./FocusBuy.vue?vue&type=template&id=18498c5c&scoped=true"
import script from "./FocusBuy.vue?vue&type=script&lang=js"
export * from "./FocusBuy.vue?vue&type=script&lang=js"
import style0 from "./FocusBuy.vue?vue&type=style&index=0&id=18498c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18498c5c",
  null
  
)

export default component.exports